module.exports = __webpack_public_path__ + "static/media/breathe-in-the-words.059e109b.txt";